import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.graphite,
  notFullBleed: true,
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default fiftyFiftyCard;